module.exports = __webpack_public_path__ + "media/49.0f3bdf8b.mp3";